export const isZoomContext = () => window.location.pathname.includes('zoom');
export const isZoomApp = () =>
  window.location.pathname.includes('zoom') && window.zoomSdk;
export const isZoomAppAgent = () => navigator.userAgent.includes('ZoomApps');
